/**
 * Re-export to prevent massive changes
 * TODO: TECH DEBT, remove dependencies from this path in favor of class inside '@controls' module once migration is completed
 */
export { FormControlMakerToken, FormControlMaker } from '@controls/model/form-control-maker';
